import { ref as O, computed as l } from "vue";
import { call as v } from "./ghl-ui.es939.js";
function M(n, m) {
  const {
    paginatedDataRef: d,
    treeMateRef: t,
    selectionColumnRef: f
  } = m, R = O(n.defaultCheckedRowKeys), w = l(() => {
    var e;
    const {
      checkedRowKeys: a
    } = n, c = a === void 0 ? R.value : a;
    return ((e = f.value) === null || e === void 0 ? void 0 : e.multiple) === !1 ? {
      checkedKeys: c.slice(0, 1),
      indeterminateKeys: []
    } : t.value.getCheckedKeys(c, {
      cascade: n.cascade,
      allowNotLoaded: n.allowCheckingNotLoaded
    });
  }), u = l(() => w.value.checkedKeys), N = l(() => w.value.indeterminateKeys), C = l(() => new Set(u.value)), g = l(() => new Set(N.value)), h = l(() => {
    const {
      value: e
    } = C;
    return d.value.reduce((a, c) => {
      const {
        key: o,
        disabled: r
      } = c;
      return a + (!r && e.has(o) ? 1 : 0);
    }, 0);
  }), y = l(() => d.value.filter((e) => e.disabled).length), L = l(() => {
    const {
      length: e
    } = d.value, {
      value: a
    } = g;
    return h.value > 0 && h.value < e - y.value || d.value.some((c) => a.has(c.key));
  }), b = l(() => {
    const {
      length: e
    } = d.value;
    return h.value !== 0 && h.value === e - y.value;
  }), S = l(() => d.value.length === 0);
  function s(e, a, c) {
    const {
      "onUpdate:checkedRowKeys": o,
      onUpdateCheckedRowKeys: r,
      onCheckedRowKeysChange: K
    } = n, i = [], {
      value: {
        getNode: _
      }
    } = t;
    e.forEach((x) => {
      var k;
      const I = (k = _(x)) === null || k === void 0 ? void 0 : k.rawNode;
      i.push(I);
    }), o && v(o, e, i, {
      row: a,
      action: c
    }), r && v(r, e, i, {
      row: a,
      action: c
    }), K && v(K, e, i, {
      row: a,
      action: c
    }), R.value = e;
  }
  function U(e, a = !1, c) {
    if (!n.loading) {
      if (a) {
        s(Array.isArray(e) ? e.slice(0, 1) : [e], c, "check");
        return;
      }
      s(t.value.check(e, u.value, {
        cascade: n.cascade,
        allowNotLoaded: n.allowCheckingNotLoaded
      }).checkedKeys, c, "check");
    }
  }
  function A(e, a) {
    n.loading || s(t.value.uncheck(e, u.value, {
      cascade: n.cascade,
      allowNotLoaded: n.allowCheckingNotLoaded
    }).checkedKeys, a, "uncheck");
  }
  function D(e = !1) {
    const {
      value: a
    } = f;
    if (!a || n.loading)
      return;
    const c = [];
    (e ? t.value.treeNodes : d.value).forEach((o) => {
      o.disabled || c.push(o.key);
    }), s(t.value.check(c, u.value, {
      cascade: !0,
      allowNotLoaded: n.allowCheckingNotLoaded
    }).checkedKeys, void 0, "checkAll");
  }
  function E(e = !1) {
    const {
      value: a
    } = f;
    if (!a || n.loading)
      return;
    const c = [];
    (e ? t.value.treeNodes : d.value).forEach((o) => {
      o.disabled || c.push(o.key);
    }), s(t.value.uncheck(c, u.value, {
      cascade: !0,
      allowNotLoaded: n.allowCheckingNotLoaded
    }).checkedKeys, void 0, "uncheckAll");
  }
  return {
    mergedCheckedRowKeySetRef: C,
    mergedCheckedRowKeysRef: u,
    mergedInderminateRowKeySetRef: g,
    someRowsCheckedRef: L,
    allRowsCheckedRef: b,
    headerCheckboxDisabledRef: S,
    doUpdateCheckedRowKeys: s,
    doCheckAll: D,
    doUncheckAll: E,
    doCheck: U,
    doUncheck: A
  };
}
export {
  M as useCheck
};
